import type { de } from "./de.js";

export const en: Record<keyof typeof de, string> = {
  "app.suiteName": "Roughly",
  "app.suiteKicker": "Roughly – an estimation game suite",
  "app.suiteTagline": "Put your gut feeling to the test.",

  "nav.langSwitch.de": "DE",
  "nav.langSwitch.en": "EN",
  "nav.langSwitch.label": "Choose language",

  "hub.loadError": "The games could not be loaded. Please try again later.",
  "hub.loading": "Loading …",

  "footer.imprint": "Imprint",
  "footer.privacy": "Privacy",
  "footer.credits": "Sources & Credits",

  "page.notFound.title": "Page not found",
  "page.notFound.body": "This page doesn't exist (anymore).",
  "page.notFound.backHome": "Back to the start page",

  "page.loadError": "This page could not be loaded.",

  "common.backHome": "Back to the start page",
  "common.loading": "Loading …",
  "common.noTimeLimit": "No time limit",

  "endscreen.round": "Round",
  "endscreen.copyResult": "Copy result",
  "endscreen.copied": "Copied!",
  "endscreen.replay": "Play again",

  "timeslip.tagline": "5 events. One order. How good is your sense of history?",
  "timeslip.start.categoriesLabel": "Categories",
  "timeslip.start.allCategories": "All",
  "timeslip.start.difficultyLabel": "Difficulty",
  "timeslip.start.difficulty.easy": "Easy",
  "timeslip.start.difficulty.normal": "Normal",
  "timeslip.start.difficulty.hard": "Hard",
  "timeslip.start.startButton": "Start game",
  "timeslip.start.notEnoughCards": "There aren't enough cards for this selection yet. Try more categories or a different difficulty.",
  "timeslip.start.loadError": "The categories could not be loaded.",
  "timeslip.start.categoriesHint": "5 rounds · ~4 min.",
  "timeslip.start.difficultyInfo.easy": "Only very well-known events, at least 25 years apart.",
  "timeslip.start.difficultyInfo.normal": "Well-known events, at least 8 years apart.",
  "timeslip.start.difficultyInfo.hard": "Even lesser-known events, sometimes just 2 years apart.",

  "timeslip.play.topLabel": "Earlier",
  "timeslip.play.bottomLabel": "Later",
  "timeslip.play.dragHandle": "Drag",
  "timeslip.play.check": "Check",
  "timeslip.play.next": "Next",
  "timeslip.play.showCorrectOrder": "Show correct order",
  "timeslip.play.showMyOrder": "Show my order",
  "timeslip.play.more": "More",
  "timeslip.play.source": "Source",
  "timeslip.play.gameLoadError": "The game could not be started.",
  "timeslip.play.summaryLine": "{correct} of {total} correct · {points} points",
  "timeslip.play.roundOf": "Round {current} of {total}",
  "timeslip.play.timeUp": "Time's up!",
  "timeslip.play.totalScore": "Total: {total} points",
  "timeslip.play.cancelGame": "Cancel game",

  "crowflight.tagline": "How far is it, really? Sort, compare, estimate.",
  "crowflight.start.regionLabel": "Region",
  "crowflight.start.world": "World",
  "crowflight.start.loadError": "The regions could not be loaded.",
  "crowflight.start.difficultyInfo.easy": "Only very well-known places, distances and latitudes clearly spread apart.",
  "crowflight.start.difficultyInfo.normal": "Well-known places, distances and latitudes moderately spread apart.",
  "crowflight.start.difficultyInfo.hard": "Even lesser-known places, distances and latitudes often very close together.",
  "crowflight.continent.africa": "Africa",
  "crowflight.continent.asia": "Asia",
  "crowflight.continent.europe": "Europe",
  "crowflight.continent.north_america": "North America",
  "crowflight.continent.south_america": "South America",
  "crowflight.continent.oceania": "Oceania",

  "crowflight.play.hint.get": "Show hint (−20 points)",
  "crowflight.play.hint.view": "View hint again",
  "crowflight.play.hint.close": "Close",
  "crowflight.play.r1.title": "Sort by distance",
  "crowflight.play.r1.near": "Nearer",
  "crowflight.play.r1.far": "Farther",
  "crowflight.play.r2.title": "North to south",
  "crowflight.play.r2.instruction": "Order these places from north to south.",
  "crowflight.play.r2.north": "North",
  "crowflight.play.r2.south": "South",
  "crowflight.play.r3.title": "Nearer or farther?",
  "crowflight.play.r3.prompt": "Which place is nearer to …",
  "crowflight.play.r3.feedback": "{a} is {distA} km away, {b} {distB} km.",
  "crowflight.play.r3.duelOf": "Duel {current} of {total}",
  "crowflight.play.r4.title": "Estimate the distance",
  "crowflight.play.r4.fromTo": "{from} to {to}",
  "crowflight.play.r4.lockIn": "Lock in",
  "crowflight.play.r4.summary": "You: {guess} km · Correct: {truth} km · {direction} → {points} points",
  "crowflight.play.r4.exact": "exactly right",
  "crowflight.play.r4.tooFar": "estimated too far",
  "crowflight.play.r4.tooClose": "estimated too close",
  "crowflight.play.gameLoadError": "The game could not be started.",

  "huesswork.tagline": "7 color boxes, one missing. Can you hit the middle of the gradient?",
  "huesswork.start.difficultyInfo.easy": "The 7 color boxes sit close together, lots of color context visible.",
  "huesswork.start.difficultyInfo.normal": "The 7 color boxes sit a medium distance apart.",
  "huesswork.start.difficultyInfo.hard": "The 7 color boxes sit far apart, little color context visible.",
  "huesswork.play.hueAriaLabel": "Hue",
  "huesswork.play.areaAriaLabel": "Saturation and brightness",
  "huesswork.play.lockIn": "Lock in",
  "huesswork.reveal.right": "Right",
  "huesswork.reveal.yourColor": "Your color",
  "huesswork.reveal.viewRightColor": "Show right color",
  "huesswork.reveal.viewMyColor": "Show my color",
  "huesswork.play.gameLoadError": "The game could not be started.",
};
